import React from 'react';
import './css/Spinner.css'; // Import the custom CSS

const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="custom-spinner"></div>
    </div>
  );
};

export default Spinner;
